(function ($) {
  'use strict';
  this.Strava2023 = function () {};
}).bind(window)(jQuery);
